import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GoalSettingHomeComponent } from './goal-setting-home/goal-setting-home.component';

const routes: Routes = [
  { path: '', component: GoalSettingHomeComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GoalSettingRoutingModule { }
